// extracted by mini-css-extract-plugin
export default {"root":"Updates_root__98aZx","container":"Updates_container__TSe4F","list":"Updates_list__36kmQ","loader":"Updates_loader__7xG9R"};